module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("“A tale of profound, irrevocable changes in the middle of America in the 1960s, as a sheltered, upper-middle-class teenager becomes transformed, not only in his own physical and spiritual self, but also in his awareness of class and race and forces of discrimination he’d never had a clue of before. The narrative is powerful in its solid simplicity and dramatic, quietly vivid events. Although the time is past, the novel is very much of the present.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("—Ellen Cooney, author of ")]), _c('span', {
    staticClass: "text_1"
  }, [_vm._v("One Night Two Souls Went Walking ")])]), _vm._v(" "), _c('p', {
    staticClass: "block_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v("This is a very lovely, clear-eyed book about a young man’s dawning awareness of extraordinary men and women, as well as the hard realities, in a Midwestern town where he’s grown up. A generous and moving evocation of people living in a world that’s undergoing change, and the ways, some deeply compassionate, others coldly cruel, with which they move into the unknown.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("—Douglas Penick, author of ")]), _c('span', {
    staticClass: "text_1"
  }, [_vm._v("Journey of the North Star")])]), _vm._v(" "), _c('p', {
    staticClass: "block_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("“The poignant tale of a teenager becoming a man over one summer in the 1960s as he learns lessons of love and evil in a small Midwestern town. The writing is lean and powerful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("—Don Trowden, author of ")]), _c('span', {
    staticClass: "text_1"
  }, [_vm._v("Normal Family")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bff6952","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0